import { FidelityStateProgresses, FidelityStates } from '@seddi/scene';
import type { SceneDesc } from '../scene/sceneTypes';

/**
 * Returns true if the scene state requires to load a garment geometry file.
 * @param fidelityState - Scene fidelity state.
 */
export const isGarmentGeometryRequired = (sceneDesc: SceneDesc) => {
  const { fidelityState, garmentGeometry } = sceneDesc;
  return (
    Boolean(garmentGeometry) ||
    (fidelityState.state === FidelityStates.TrueSeams &&
      fidelityState.progress === FidelityStateProgresses.Done) ||
    fidelityState.state === FidelityStates.DigitalTwin
  );
};
